// extracted by mini-css-extract-plugin
export default {"msgM":"_9c43443e34"};